export function claimReducer(state, action) {
  switch (action.type) {
    case "loadClaims":
      return {
        ...state,
        claims: action.claims,
      };
    case "loadMembers":
      return {
        ...state,
        members: action.members,
      };
    case "removeClaim":
      return {
        ...state,
        claims: state.claims.filter(
          (item) => parseInt(item.id) != parseInt(action.claimId)
        ),
      };
    default:
      throw new Error();
  }
}
